import axiosInstance from "./apiinterseptor";
import { toast } from "react-hot-toast";

export interface CampusDriveApplication {
  _id: string;
  fullName: string;
  email: string;
  phone: string;
  status: string;
  createdAt: string;
  jobInfo?: {
    jobId?: string;
    title?: string;
    location?: string;
    eligibleForCampusDrive?: boolean;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface CampusDriveApplicationsQuery {
  search?: string;
  status?: string;
  jobId?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
}

export interface CampusDriveApplicationsResponse {
  data: CampusDriveApplication[];
  page: number;
  limit: number;
  totalResults: number;
  totalPages: number;
  jobOptions: { jobId: string; title: string }[];
}

export const getCampusDriveApplications = async (
  query: CampusDriveApplicationsQuery = {}
): Promise<CampusDriveApplicationsResponse> => {
  try {
    const response = await axiosInstance.get("/jobs/campus-drive-applications", {
      params: query,
    });
    const rawData = response.data || {};
    const data = Array.isArray(rawData.data) ? rawData.data : [];
    const page =
      typeof rawData.page === "number"
        ? rawData.page
        : typeof query.page === "number"
        ? query.page
        : 1;
    const limit =
      typeof rawData.limit === "number"
        ? rawData.limit
        : typeof query.limit === "number"
        ? query.limit
        : 10;
    const totalResults =
      typeof rawData.totalResults === "number" ? rawData.totalResults : data.length;
    const totalPages =
      typeof rawData.totalPages === "number"
        ? rawData.totalPages
        : totalResults > 0
        ? Math.ceil(totalResults / limit)
        : 1;
    const jobOptions =
      Array.isArray(rawData.jobOptions)
        ? rawData.jobOptions
            .map((option: any) => {
              const jobId =
                typeof option?.jobId === "string" && option.jobId.trim()
                  ? option.jobId.trim()
                  : typeof option?._id === "string"
                  ? option._id.trim()
                  : "";
              const title =
                typeof option?.title === "string" && option.title.trim()
                  ? option.title.trim()
                  : jobId;
              return { jobId, title };
            })
            .filter((option: { jobId: string; title: string }) => option.jobId)
        : [];

    return {
      data,
      page,
      limit,
      totalResults,
      totalPages,
      jobOptions,
    };
  } catch (error: any) {
    toast.error(
      `Failed to fetch campus drive applications: ${error?.response?.data?.message || "Unknown error"}`
    );
    throw error;
  }
};

